import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import Backdrop from './Backdrop';
import { useModal } from './ModalContext';
import X from './x.svg';

interface ModalProps {
  title?: string;
  maxWidth?: number;
}

function Modal({ title, maxWidth, children }: PropsWithChildren<ModalProps>) {
  const modal = useModal();

  return (
    <Backdrop>
      <StyledContainer onClick={(e) => e.stopPropagation()} $maxWidth={maxWidth}>
        {title && (
          <header className='modal-header'>
            <h3 className='modal-title'>{title}</h3>
          </header>
        )}

        <button className='modal-close' onClick={modal.close}>
          <img src={X} alt='modal-close' />
        </button>

        <section className='modal-body'>{children}</section>
      </StyledContainer>
    </Backdrop>
  );
}

const StyledContainer = styled.article<{ $maxWidth?: number }>`
  padding: 32px;
  border-radius: 16px;
  background-color: white;
  position: relative;
  width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth + 'px' : 'fit-content')};
  font-family: 'Pretendard';

  > .modal-header {
    margin-bottom: 28px;

    > .modal-title {
      margin: 0;
      font-size: 20px;
      font-weight: 700;
      color: black;
    }
  }

  > .modal-close {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
    position: absolute;
    top: 18px;
    right: 18px;
  }
`;

export default Modal;
